import {Item as DropdownItem} from '@wandb/weave/components/DropdownMenu';
import React, {type ReactNode} from 'react';

type RunRowHeaderOptionProps = {
  disabled?: boolean;
  icon: ReactNode;
  infoLabel?: ReactNode;
  label: ReactNode;
  onSelect: () => void;
};

export function RowHeaderMenuOption({
  disabled,
  icon,
  infoLabel,
  label,
  onSelect,
}: RunRowHeaderOptionProps) {
  return (
    <DropdownItem onSelect={onSelect} disabled={disabled}>
      <div className="flex flex-row items-center gap-8 grow">
        {icon}
        <div className="grow shrink">{label}</div>
        <div style={{color: disabled ? 'inherit' : 'var(--tertiary-text)'}}>
          {infoLabel}
        </div>
      </div>
    </DropdownItem>
  );
}
